import {IOfferDetail} from "../types/IOfferDetail";
import {getOfferDisplayStatus, IOfferDisplayStatusData} from "./get_offer_display_status";

export type IOfferArchivedData = IOfferDisplayStatusData & {configuration: Pick<IOfferConfiguration["configuration"], "limited_presentation" | "display_type">};
type IOfferConfiguration = Pick<IOfferDetail, "configuration">;

export function isOfferArchived(offer: IOfferArchivedData) {
    const displayStatus = getOfferDisplayStatus(offer);
    return offer.configuration.limited_presentation && displayStatus === "limited";
}
